import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { BaseComponent } from 'src/app/base/base.component';
import { ConfigService } from 'src/app/services/config/config.service';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { UserDataService } from 'src/app/services/user-data-service';
import { ExportColumnInfo, ExportSaveConfigModel, ExportViewModel } from 'src/app/viewModels/exportViewModel';
import { UntypedFormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { CacheKeyType } from 'src/app/domainObjects/transformType';

export interface IExportTableDelegate {

  onRefreshClicked(sender: ExportViewModel): void;

}

@Component({
    selector: 'app-export-output-data',
    templateUrl: './export-output-data.component.html',
    styleUrls: ['./export-output-data.component.css'],
    standalone: false
})
export class ExportOutputDataComponent extends BaseComponent implements OnInit {
  @Input() viewModelExport: ExportViewModel;
  @Input() exportcolumninfo: ExportColumnInfo[];
  @Input() public hideOptions = false;
  @Input() public delegate?: IExportTableDelegate = null;
  // @Output() applyFilter = new EventEmitter<string>();
  // @Output() clearFilter = new EventEmitter<string>();
  @ViewChildren('targetInput') inputs!: QueryList<ElementRef>;
  @Output() moveToNextField = new EventEmitter<'forward' | 'reverse'>();

  fileDelimiterControl = new UntypedFormControl('');
  delimiterOptions: Observable<string[]>;
  delimiters = ['|', ',', '[tab]', '~'];

  fileExtensionControl = new UntypedFormControl('');
  extensionOptions: Observable<string[]>;
  extensions = ['.txt', '.csv'];
  isUseSource = true;

  constructor(
    errorService: ErrorReportingService,
    matDialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private configService: ConfigService,
    private userData: UserDataService,
    private fileDownloadService: FileDownloadService) {

    super(errorService, matDialog);
  }
  
  dataSourceExport: MatTableDataSource<any>;
  displayedColumnsExport: string[];
  displayedSourceColumns: string[];

  ngOnInit(): void {
    //this.viewModel = this.ingestConfigViewModel.fileDataConnector;
    //this.importSetupViewModel.fileDataConnectorViewModel = this.viewModel;
    this.delimiterOptions = this.fileDelimiterControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterdelimiter(value || '')),
    );
    this.extensionOptions = this.fileExtensionControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterextension(value || '')),
    );
  }
  private _filterdelimiter(value: string): string[] {

    return this.delimiters.filter(delimiter => delimiter.includes(value));
  }
  private _filterextension(value: string): string[] {

    return this.extensions.filter(extension => extension.includes(value));
  }
  async bindData(): Promise<void> {
    try {
      //this.noDataTitle = emptyResultText;

      this.dataSourceExport = new MatTableDataSource<ExportColumnInfo>();
      var config=this.userData.getSelectedConfigJson();
      var transform=config.transforms.find(tran=>tran.guid == this.userData.getTransformId());
      if(transform.export){
        this.viewModelExport.fileDelimiter=transform.export.fileDelimiter;
        this.viewModelExport.fileExtension=transform.export.fileExtension;
        this.viewModelExport.fileType=transform.export.fileType;
        this.isUseSource=transform.export.isUseSource;
        this.exportcolumninfo.forEach( r =>{
            var column = transform.export.includeColumns.find(col => col.name == r.name);
            if(column){
              r.index = column.index;
              r.isinclude = column.isinclude;
              r.targetcolumn = column.targetcolumn;
            }
        });
      }
      this.dataSourceExport.data = this.exportcolumninfo.sort((a, b) => a.index - b.index);
      
      this.displayedColumnsExport = this.displayedColumnsExport;
       
      this.cdRef.detectChanges();

    } catch (err) {
      //this.isGettingData.next(false);
      this.displayError('Failed to preview data.', 'Error', err);
    }
  }
  onExportIncludeChanged(event: MatSlideToggleChange): void {
    this.exportcolumninfo.forEach( r => r.isinclude = event.checked);
  }
  async onClickExportOutput(){
    const busyIndicator = this.showBusyDialog('Please wait...');
    try {

      this.viewModelExport.includeColumns=this.exportcolumninfo;//.filter(m=>m.isinclude==true).map(x=>x.name);
      const nodeDetails = this.userData.getSelectedNodeDetails();
      if(nodeDetails.nodeboxtypename == "Joiner"){
         this.viewModelExport.cacheKeyType = CacheKeyType.transformer;
      } else {
         this.viewModelExport.cacheKeyType = CacheKeyType.transformerOutput;
      }
      var result = await this.configService.exportDataFile(this.viewModelExport);
      //console.log("result : ",result);
      this.fileDownloadService.downloadFile(result.file_path,result.file_name);
      busyIndicator.close();

      // The backend degrades gracefully instead of failing the whole export when a requested
      // column is no longer present (e.g. a stale "Include in Results" selection) -- the
      // Analyst still gets their file; this just tells them something was left out, after the
      // fact, rather than blocking them with an error dialog over a partial/recoverable issue.
      if (result.warnings?.length) {
        this.displayWarning(result.warnings.join('\n'), 'Export completed with warnings');
      }

    } catch (err: any) {
      //this.isGettingData.next(false);
      busyIndicator.close();
      // Root cause, 2026-10-01 (the Architect: "we need to not have these non-recoverable errors
      // on exports in the future"): this used to always show the same static "Failed to export
      // data." text regardless of what the backend actually said -- the real, specific,
      // actionable message (e.g. "Please run this transformer before exporting") only ever
      // reached isDevMode's stack-trace detail panel, never a real Analyst. Showing the backend's
      // own message here (falling back to the generic text only if none is present) matches the
      // same err?.error?.error pattern already used elsewhere in this app (e.g.
      // audit-compiler-dialog.component.ts).
      const backendMessage = err?.error?.error ?? err?.message;
      this.displayError(backendMessage ?? 'Failed to export data.', 'Error', err);
    }
  }
  dropExportColumnTable(event: CdkDragDrop<MatTableDataSource<ExportColumnInfo>>): void {
    const prevIndex = event.previousIndex;
    const currentItem: ExportColumnInfo = event.item.data;
    currentItem.index = prevIndex;
    moveItemInArray(this.exportcolumninfo, prevIndex, event.currentIndex);
    for (let i = 0; i < this.exportcolumninfo.length; i++) {
      this.exportcolumninfo[i].index = i + 1;
    }
    this.exportcolumninfo.sort((a, b) => a.index - b.index);
    this.dataSourceExport.data = this.exportcolumninfo;
  }
  OnDelimiterChange(){
    if(this.viewModelExport.fileDelimiter==","){
      this.viewModelExport.fileExtension=".csv";
    }else{
      this.viewModelExport.fileExtension=".txt";
    }
  }
  onUseSourceChanged(event: MatSlideToggleChange): void {
    if(event.checked){
      this.exportcolumninfo.forEach( r => r.targetcolumn = r.name);
    }else{
      this.exportcolumninfo.forEach( r => r.targetcolumn = '');
    }
  }
  async saveExportConfig(): Promise<void> {
    const busyIndicator = this.showBusyDialog('Please wait...');
    try {
      if(this.isUseSource==false){
        for (const col of this.exportcolumninfo) {
          //console.log(col.isinclude,col.name,col.targetcolumn);
          if(col.isinclude){
            if(col.targetcolumn=="" || col.targetcolumn==null){
              this.displayWarning("Please select target column mapping for included columns.", "Please fix the validation error.", "", (onClosed) => {});
              return;
            }
          }
        }
      }
      var saveconfig=new ExportSaveConfigModel(this.viewModelExport.fileDelimiter,this.viewModelExport.fileExtension,this.viewModelExport.fileType,this.isUseSource,this.exportcolumninfo);
      var config=this.userData.getSelectedConfigJson();
      var transform=config.transforms.find(tran=>tran.guid == this.userData.getTransformId());
      transform.export = saveconfig;
      config = await this.configService.upsertConfig(config);
    } catch (err) {
      busyIndicator.close();
      this.displayError('Failed to save config data.', 'Error', err);
    }finally {
      busyIndicator.close();
    }
  }
  
  handleMoveToField(direction: 'forward' | 'reverse',index: number, event: Event){
    event.preventDefault(); // 🔥 VERY IMPORTANT (prevents double tab)

    if (direction === 'reverse') {
      this.focusPreviousInput(index);
    } else {
      this.focusNextInput(index);
    }
  }

  focusNextInput(index: number) {
    const inputsArray = this.inputs.toArray();
    for (let i = index + 1; i < inputsArray.length; i++) {
      const el = inputsArray[i].nativeElement;

      if (!el.disabled) {   // ✅ skip disabled
        el.focus();
        el.scrollIntoView({ block: 'center' });
        break;
      }
    }
  }

  focusPreviousInput(index: number) {
    const inputsArray = this.inputs.toArray();
    for (let i = index - 1; i >= 0; i--) {
      const el = inputsArray[i].nativeElement;

      if (!el.disabled) {   // ✅ skip disabled
        el.focus();
        el.scrollIntoView({ block: 'center' });
        break;
      }
    }
  }
}
